/* global axios */
import ApiClient from './ApiClient';
import { resourcePath, requestConfig } from './lais/httpHelpers';
import { PORTAL_INTEGRATIONS_ENDPOINTS } from './lais/endpoints';

class PortalIntegrationsAPI extends ApiClient {
  constructor() {
    super('portal_integrations', { accountScoped: true });
  }

  status(portal = 'olx') {
    return axios.get(
      resourcePath(this.url, portal, PORTAL_INTEGRATIONS_ENDPOINTS.status),
      requestConfig()
    );
  }

  preflight(portal = 'olx') {
    return axios.get(
      resourcePath(this.url, portal, PORTAL_INTEGRATIONS_ENDPOINTS.preflight),
      requestConfig()
    );
  }

  testConnection(portal = 'olx') {
    return this.preflight(portal);
  }

  configure(portal = 'olx', payload = {}) {
    return axios.post(
      resourcePath(this.url, portal, PORTAL_INTEGRATIONS_ENDPOINTS.configure),
      payload,
      requestConfig()
    );
  }

  authorizeUrl(portal = 'olx', params = {}) {
    return axios.get(
      resourcePath(
        this.url,
        portal,
        PORTAL_INTEGRATIONS_ENDPOINTS.authorizeUrl
      ),
      requestConfig(params)
    );
  }

  callback(portal = 'olx', payload = {}) {
    return axios.post(
      resourcePath(this.url, portal, PORTAL_INTEGRATIONS_ENDPOINTS.callback),
      payload,
      requestConfig()
    );
  }

  publish(portal = 'olx', payload = {}) {
    return axios.post(
      resourcePath(this.url, portal, PORTAL_INTEGRATIONS_ENDPOINTS.publish),
      { ...payload, sync_action: payload.sync_action || 'publish' },
      requestConfig()
    );
  }

  update(portal = 'olx', payload = {}) {
    return this.publish(portal, { ...payload, sync_action: 'update' });
  }

  unpublish(portal = 'olx', payload = {}) {
    return this.publish(portal, { ...payload, sync_action: 'unpublish' });
  }

  reconcile(portal = 'olx', payload = {}) {
    return axios.post(
      resourcePath(this.url, portal, PORTAL_INTEGRATIONS_ENDPOINTS.reconcile),
      payload,
      requestConfig()
    );
  }

  importListings(portal = 'olx', payload = {}) {
    return axios.post(
      resourcePath(this.url, portal, PORTAL_INTEGRATIONS_ENDPOINTS.import),
      payload,
      requestConfig()
    );
  }
}

export default new PortalIntegrationsAPI();
